/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_CancelInputs */

const cs_tasks_protocol_cancel = /** @type {(inputs: Tasks_Protocol_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit podpis`)
};

const en_tasks_protocol_cancel = /** @type {(inputs: Tasks_Protocol_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel signing`)
};

/**
* | output |
* | --- |
* | "Cancel signing" |
*
* @param {Tasks_Protocol_CancelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_cancel = /** @type {((inputs?: Tasks_Protocol_CancelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_CancelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_cancel(inputs)
	return cs_tasks_protocol_cancel(inputs)
});